import React, { useState, useEffect } from 'react';
import {
  formatDateMonth,
  formatPrice,
  KTSVG,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import Select, { MultiValue, SingleValue } from 'react-select';
import { statusSelectStyles } from '../../../inventario/entrabas_salidas/models/statusSelectStyles';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import 'flatpickr/dist/flatpickr.min.css';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { Filter } from './Filter';
import { PagarComisionModal } from '../_modals/PagarComisionModal';
import { getAllCommissions } from '../../../../service/pagos/comisiones';

type OptionType = {
  value: string;
  label: string;
};

const View: React.FC = () => {
  const [reloadGrid, setReloadGrid] = useState<number>();
  const [loadingView, setloadingView] = useState(true);
  const [visivilityModalDevolucion, setVisivilityModalDevolucion] =
    useState<boolean>(false);
  const [dataSends, setDataSends] = useState<any[]>([]);
  const [dateState, setDateState] = useState<string[]>([]);
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  type YearOption = { value: string; label: string };
  const [selectedOptionStatus, setSelectedOptionStatus] =
    useState<YearOption | null>(null);

  const [initFilterValues, setInitFilterValues] = useState({
    type_stock_id: 0,
    status_id: 0,
    movements_id: 0,
    user_id: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });

  const fetchPost = async () => {
    try {
      const filters = {
        start_date: dateState[0],
        end_date: dateState[1],
        balance_filter: statusFilter.join(','), // ✅ ahora es string
      };

      const sends = await getAllCommissions(filters);
      if (sends) setDataSends(sends);
    } catch (error) {
      console.error(error);
    } finally {
      setloadingView(false);
    }
  };

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [dataSends]);

  useEffect(() => {
    fetchPost();
  }, [dateState, statusFilter, reloadGrid]);

  const commissionTypeMap: Record<number, string> = {
    31: 'Saldo Virtual',
    32: 'Efectivo',
  };

  const columns: any = [
    {
      id: 'last_pending_commission_date',
      name: <div className="fw-bolder text-muted me-5">Últ. Comisión</div>,
      selector: (row: any) => row.last_pending_commission_date,
      cell: (row: any) =>
        row.last_pending_commission_date
          ? formatDateMonth(row.last_pending_commission_date)
          : 'N/A',
      sortable: true,
    },

    {
      id: 'type',
      name: <div className="fw-bolder text-muted me-5">Tipo cliente</div>,
      selector: (row: any) => row.company?.type?.name,
      cell: (row: any) => row.company?.type?.name || 'N/A',
      sortable: true,
    },

    {
      id: 'commission_type',
      name: <div className="fw-bolder text-muted me-5">Tipo comisión</div>,

      selector: (row: any) =>
        commissionTypeMap[row.company?.account?.type_commision_id] || 'N/A',

      cell: (row: any) =>
        commissionTypeMap[row.company?.account?.type_commision_id] || 'N/A',

      sortable: true,
    },

    {
      id: 'company_name',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => row.company?.name,
      cell: (row: any) => row.company?.name || 'N/A',
      sortable: true,
    },

    {
      id: 'pending_balance',
      name: <div className="fw-bolder text-muted me-5">Por pagar</div>,
      selector: (row: any) => Number(row.pending_balance),
      cell: (row: any) => {
        const balance = Number(row.pending_balance) || 0;
        return formatPrice(balance, 'es-MX', 'MXN', 2, 2);
      },
      sortable: true,
    },

    {
      id: 'status',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => {
        const balance = Number(row.pending_balance) || 0;
        return balance === 0 ? 'Al corriente' : 'Pendiente';
      },
      cell: (row: any) => {
        const balance = Number(row.pending_balance) || 0;

        if (balance === 0) {
          return (
            <span className="fw-normal badge badge-light-success text-center d-inline-block">
              Al corriente
            </span>
          );
        } else {
          return (
            <span className="fw-normal badge badge-light-warning text-center d-inline-block">
              Pendiente
            </span>
          );
        }
      },
      sortable: true,
    },
  ];

  const handleCustomerChangeStatus = (selected: SingleValue<YearOption>) => {
    setSelectedOptionStatus(selected);
    setStatusFilter(selected ? [selected.value] : []);
  };

  const statusOptions: OptionType[] = [
    { value: 'PENDING', label: 'Pendiente' },
    { value: 'ZERO', label: 'Al corriente' },
  ];

  const customSelectStyles = {
    clearIndicator: (provided: any) => ({
      ...provided,
      padding: '2px',
      fontSize: '12px',
      svg: {
        height: '12px',
        width: '12px',
      },
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: '#181c32',
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: '#7E8199',
    }),
    control: (provided: any) => ({
      ...provided,
      width: '135px',
      border: '1px solid #e4e6ef',
      marginTop: '5px',
      borderRadius: '6px',
      boxShadow: 'none',
      backgroundColor: 'white',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      maxHeight: '30px',
      overflowY: 'auto',
      paddingBottom: 0,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? state.data.value === 'ZERO'
          ? '#50cd89'
          : '#ffc700'
        : state.isFocused
        ? state.data.value === 'ZERO'
          ? '#e8fff3'
          : '#fff8dd'
        : 'white',
      color: state.isSelected ? 'white' : '#181c32',
      cursor: 'pointer',
      ':active': {
        backgroundColor: state.data.value === 'ZERO' ? '#50cd89' : '#ffc700',
      },
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      color: state.data.value === 'ZERO' ? '#50cd89' : '#ffc700',
      fontWeight: 500,
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      type_stock_id: 0,
      status_id: 0,
      movements_id: 0,
      user_id: '',
      init_date: '',
      end_date: '',
      filter: 0,
    });
    setDateState([]);
  };

  useEffect(() => {
    const statusIdsStatus = selectedOptionStatus
      ? selectedOptionStatus.value
      : '';

    setInitFilterValues((prev: any) => ({
      ...prev,
      status_id: statusIdsStatus,
    }));
  }, [selectedOptionStatus]);

  const normalActivation = () => {
    setVisivilityModalDevolucion(!visivilityModalDevolucion);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className="card card-xxl-stretch mb-5 mb-xl-12">
            <div className="card-header border-0 pt-5 d-flex justify-content-between align-items-start">
              <div className="d-flex align-items-center gap-4">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
                <Select<YearOption, false>
                  options={statusOptions}
                  placeholder={'Estatus'}
                  onChange={handleCustomerChangeStatus}
                  value={selectedOptionStatus}
                  isClearable
                  noOptionsMessage={() => <span>No hay registros</span>}
                  menuPortalTarget={document.body}
                  styles={customSelectStyles}
                />
              </div>
              <div className="card-toolbar">
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Nuevo pago"
                >
                  <a
                    className="btn btn-sm btn-light-primary"
                    onClick={normalActivation}
                  >
                    <KTSVG
                      path="/media/icons/duotune/arrows/arr075.svg"
                      className="svg-icon-5 svg-icon-gray-500 me-1"
                    />
                    Nuevo pago
                  </a>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={dataSends} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <PagarComisionModal
        show={visivilityModalDevolucion}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModalDevolucion(!visivilityModalDevolucion);
        }}
        handleRefresh={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
        }}
      />
    </>
  );
};

export { View };
